import {put} from "redux-saga/effects";

import axios from "../../../../../api/axios"

import * as actions from "../../../../actions";
import * as api from "../../../../../api";
import {generateDynamicRoute} from "../../../../../utils/utils";

export function* etudiantMesCoursFetchCoursSaga(action) {

    yield put(actions.etudiantMesCoursFetchCoursStart());

    const coursId = action.payload.coursId;


    try {
        const response = yield axios.get(generateDynamicRoute(api.studentFetchCourse,[{toReplace:":coursId",value:coursId}]));
        console.log(response.data);
        yield put(actions.etudiantMesCoursFetchCoursSuccess(response.data));
    } catch (error) {
        if(error.response) {
            yield put(actions.etudiantMesCoursFetchCoursFail(error.response.data.error));
        }else {
            yield put(actions.etudiantMesCoursFetchCoursFail("There's an error!"));
        }
    }

}